<h2 matDialogTitle>Preview</h2>
<button class="close" mat-button type="button" (click)="onclose()">
  <mat-icon>close</mat-icon>
</button>
<div class="ipad_amn_break mail-content ml-1" [innerHTML]="data"></div>
